import { Component, Input, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-multi-images-service',
  templateUrl: './multi-images-service.component.html',
  styleUrls: ['./multi-images-service.component.css'],
})
export class MultiImagesServiceComponent {
  @Input() data!: any;
  @Input() language!: string;
 
}
